import React from "react";
import NewTr from "../../common/table/newTr";
import Th from "../../common/table/th";

export function CabecalhoTabelaFaturaEnergia() {
    return (
        <NewTr backgroundColorTr="#FFFFFF" backgroundColorTd="#F9F9F9">
            <Th sticky style={{ fontSize: "0.85rem" }} minWidth={120} alignCenter title="Status da Importação das Faturas de Energia Elétrica">
                Status Imp. Fatura
            </Th>
            <Th sticky style={{ fontSize: "0.85rem" }} minWidth={65} alignCenter title="Status da Importação de Produção de Energia Elétrica Solar">
                Status Imp. Prod. Solar
            </Th>
            <Th sticky style={{ fontSize: "0.85rem" }} minWidth={75} alignCenter title="Saldo de Produção Solar da Fatura de Energia Elétrica">
                Geração Solar (kWh)
            </Th>
            <Th sticky style={{ fontSize: "0.85rem" }} minWidth={75} alignCenter>
                Competência
            </Th>
            <Th sticky style={{ fontSize: "0.85rem" }} alignCenter minWidth={65}>
                Cliente
            </Th>
            <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                Nº da Nota Fiscal
            </Th>
            <Th sticky style={{ fontSize: "0.85rem" }} alignCenter minWidth={65}>
                UC
            </Th>
            <Th sticky style={{ fontSize: "0.85rem" }} minWidth={150} alignCenter>
                Característica de Conexão com Distribuidora de Energia
            </Th>
            <Th sticky style={{ fontSize: "0.85rem" }} minWidth={75} alignCenter>
                ICMS (%)
            </Th>
            <Th sticky style={{ fontSize: "0.85rem" }} minWidth={75} alignCenter>
                Tributos
            </Th>
            <Th sticky style={{ fontSize: "0.85rem" }} minWidth={75} alignCenter>
                Despesas Adicionais de Mercado Livre (ACL)
            </Th>
            <Th sticky style={{ fontSize: "0.85rem" }} alignCenter>
                Total (R$)
            </Th>

            <Th sticky style={{ fontSize: "0.85rem" }} alignCenter>
                Energia (kWh)
            </Th>

            <Th sticky style={{ fontSize: "0.85rem" }} minWidth={50} alignCenter>
                Demanda Contratada (kW)
            </Th>

            <Th sticky style={{ fontSize: "0.85rem" }} minWidth={50} alignCenter>
                Demanda Faturada
            </Th>

            <Th sticky style={{ fontSize: "0.85rem" }} minWidth={60} alignCenter>
                E. Reativo (kvarh)
            </Th>
            <Th sticky style={{ fontSize: "0.85rem" }} minWidth={65} alignCenter>
                Gasto Reativo (R$)
            </Th>
            <Th sticky style={{ fontSize: "0.85rem" }} minWidth={34} alignCenter>
                Tarifa
            </Th>
            <Th sticky style={{ fontSize: "0.85rem" }} alignCenter>
                PDF
            </Th>
        </NewTr>
    );
}
